import { BrowserModule } from '@angular/platform-browser';
import { ApplicationRef,NgModule } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { DxPopupModule,DxFormModule,DxAccordionModule, DxButtonModule, DxNumberBoxModule, DxSelectBoxModule, DxDataGridModule, DxDropDownBoxModule, DxTreeViewModule, DxCheckBoxModule, DxChartModule } from 'devextreme-angular';
import { environment } from '../environments/environment';
import { RouterModule, Routes } from '@angular/router';
import { MsalComponent } from './msalcomponent/msal.component';
import { PumpcalcCoreModule, RestDataService, SolverApiService, LoginService } from 'pumpcalc-core';
import { UnitsService, StatusBarService } from 'projects/pumpcalc-core/src/public-api';
import { AppComponent } from './app.component';
import { ParametersComponent } from './parameters/parameters.component';
import { PipeFormComponent } from './pipe-form/pipe-form.component';
import { ResultTableComponent } from './result-table/result-table.component';
import { BoundaryConditionFormComponent } from './boundary-condition-form/boundary-condition-form.component';
import { DiagramComponent } from './diagram/diagram.component';
import { FormSectionService } from './form-section.service';
import { ValidationService } from './validation.service'
import { ResultsService } from '../app/results.service';
import { RangeVariableFormComponent } from './range-variable-form/range-variable-form.component';
import { RangeVariableComponent } from './range-variable/range-variable.component';
import { CalculationComponent } from './calculation/calculation.component';
import { RangedResultChartComponent } from './ranged-result-chart/ranged-result-chart.component';
import { RangedResultComponent } from './ranged-result/ranged-result.component';
import { ChartOptionsComponent } from './chart-options/chart-options.component';
import { ResultTableButtonsComponent } from './result-table-buttons/result-table-buttons.component';
import { ResultTableService } from './result-table/result-table.service';
import { MsalRedirectComponent } from '@azure/msal-angular';

const appRoutes: Routes = [
  // { path: '', component:LoginComponent , pathMatch: 'full'},
  // { path: '**', component:LoginComponent}
];

export const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;
export const isIframe = window !== window.parent && !window.opener;


@NgModule({
  declarations: [
    AppComponent,
    ParametersComponent,
    PipeFormComponent,
    ResultTableComponent,
    BoundaryConditionFormComponent,
    DiagramComponent,
    RangeVariableFormComponent,
    RangeVariableComponent,
    CalculationComponent,
    MsalComponent,
    RangedResultChartComponent,
    RangedResultComponent,
    ChartOptionsComponent,
    ResultTableButtonsComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    PumpcalcCoreModule.forRoot({ app_config: environment }),
    DxAccordionModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxDataGridModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxCheckBoxModule,
    DxChartModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule,
    RouterModule.forRoot(appRoutes),
    DxFormModule,
    DxPopupModule
  ],
  providers: [
    HttpClient,
    FormSectionService,
    ValidationService,
    ResultsService,
    UnitsService,
    RestDataService,
    SolverApiService,
    StatusBarService,
    LoginService,
    ResultTableService
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {
}
